import React from 'react';
import './PC.css';
import ALeushchenko from '../../img/pc1/ALeushchenko.png'
import OLeushchenko from '../../img/pc1/OLeushchenko.png'
import Orlova from '../../img/pc1/Orlova.png'
import Kazlauskas from '../../img/pc1/Kazlauskas.png'

export default class PC extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pc: [
        {
          photo: ALeushchenko,
          name: 'Anna Leushchenko',
          position: 'Flutter GDE, Senior Staff Engineer at Tide',
          ln: 'https://www.linkedin.com/in/annaleushchenko/',
          tw: 'https://twitter.com/AnnaLeushchenko',
          github: 'https://github.com/foxanna',
        },
        {
          photo: OLeushchenko,
          name: 'Oleksandr Leushchenko',
          position: 'Flutter GDE, Senior Staff Engineer at Tide',
          ln: 'https://www.linkedin.com/in/olexale/',
          tw: 'https://twitter.com/olexale',
          github: 'https://github.com/olexale',
        },
        {
          photo: Orlova,
          name: 'Daria Orlova',
          position: 'Flutter GDE, Creator of Bunny Search & Native Pal',
          ln: 'https://www.linkedin.com/in/daria-orlova-47a44110a/',
          tw: 'https://twitter.com/dariadroid',
          github: 'https://github.com/darjaorlova',
        },
        {
          photo: Kazlauskas,
          name: 'Mangirdas Kazlauskas',
          position: 'Flutter GDE, Mobile Tech Lead at Billo',
          ln: 'https://www.linkedin.com/in/mangirdas-kazlauskas/',
          tw: 'https://twitter.com/mkobuolys',
          website: 'https://kazlauskas.dev/',
        },
      ],
      // pcHide: [
      // ],
      hide: true,
    }
    this.togglePC = this.togglePC.bind(this);
  }

  togglePC() {
    this.setState({ hide: !this.state.hide });
  }

  renderPC(item, i) {
    return (
      <div id="pc" className="pc_item" key={`team-${i}`}>
        <div className="pc_img_block">
          <img className="team_img" src={item.photo} alt={item.name} />
        </div>
        <div className="pc_info">
          <p className="pc_name">{item.name}</p>
          <p className="pc_position">{item.position}</p>
          <div className="pc_links">
            {item.fb && <a className="pc_link social_fb" target='_blank' rel="noreferrer" href={item.fb}></a>}
            {item.ln && <a className="pc_link social_ln" target='_blank' rel="noreferrer" href={item.ln}></a>}
            {item.tw && <a className="pc_link social_tw" target='_blank' rel="noreferrer" href={item.tw}></a>}
            {item.github && <a className="pc_link social_github" target='_blank' rel="noreferrer" href={item.github}></a>}
            {item.website && <a className="pc_link social_website" target='_blank' rel="noreferrer" href={item.website}></a>}
            {item.youtube && <a className="pc_link social_yb" target='_blank' rel="noreferrer" href={item.youtube}></a>}
          </div>
          {/* <img className="pc_logo" src={item.logo} alt="" /> */}
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className="pc container" id='pc'>
        <h2>Program committee</h2>
        <div className='pc_wrap'>
          <div className="pc_block">
            {this.state.pc.map((item, i) => this.renderPC(item, i))}
            {/* {!this.state.hide && this.state.pcHide.map((item, i) => this.renderPC(item, i))} */}
          </div>
          {/* <button className='pc_btn' onClick={this.togglePC}>{this.state.hide ? 'Show more' : 'Hide'}</button> */}
        </div>
      </div>
    )
  }
}